// extracted by mini-css-extract-plugin
module.exports = {"root":"AboutCard-module--root--2ovOK","number":"AboutCard-module--number--2s5lZ","title":"AboutCard-module--title--2UkSx","description":"AboutCard-module--description--3JpbS"};